import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import MainContentLayout from '../../../components/MainContentLayout'
import { TracksRouter } from '../../../utils/routes/MusicRoutes'
import { Howler } from 'howler'

const menu: ItemType<MenuItemType>[] = [
  {
    label: 'All',
    key: 'all',
  },
  {
    label: 'Upload',
    key: 'upload',
  },
]

export default function Tracks() {
  return (
    <MainContentLayout
      navigationHeader={{
        headerMenu: menu,
        navigationPrefix: '/music/songs/',
      }}
    >
      <TracksRouter />
    </MainContentLayout>
  )
}
